import { render, staticRenderFns } from "./ResetConfirm.vue?vue&type=template&id=5d458152&scoped=true&"
import script from "./ResetConfirm.vue?vue&type=script&lang=js&"
export * from "./ResetConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ResetConfirm.vue?vue&type=style&index=0&id=5d458152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d458152",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VTextField})
